import React from "react";
import SlotM from "./SlotM";

const Slotmachine = () => {
    return    <>
   <h1>🎰 Welcome to <span> Slot Machine</span> 🎰</h1>
       <SlotM x="😃" y="😃" z="😃"/>
       <SlotM x="😃" y="😃" z="😆"/>
       <SlotM x="😃" y="😃" z="😂"/>
       <SlotM x="😃" y="😇" z="😂"/>
    </>;
};

export default Slotmachine;